module.exports = __webpack_public_path__ + "static/media/edvardsson.e7c9a111.jpg";